const Results = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  ATTEMPTED: 'attempted',
  UNAVAILABLE: 'unavailable',
  NOT_AVAILABLE: 'not_available',
  DECLINED: 'declined',
  MANUAL_REVIEW: 'manual_review',
  EXPIRED: 'expired',
};

module.exports = Results;
